<template>
  <div>
    <div v-if="fileSize !== 0" class="main">
      <!--图片墙-->
      <div class="pictures"
        :style="{ width: `${150 * files.length - 1}px`, transform: `translateX(-${index / files.length * 100}%)` }">

        <!--图片-->
        <div class="picture" v-for="(file, index) in files" :key="index">
          <img :src="getImgUrl(file)" @error="handleImageError">
        </div>
      </div>

      <!--右上角标-->
      <div class="triangle"></div>
      <div class="remark">{{ isVideo(files[index]) ? 'm' : 'p' }}</div>

      <!--遮罩层-->
      <div class="preview" @mouseenter="pauseAutoPlay" @mouseleave="resumeAutoPlay">
        <i class="el-icon-arrow-left" @click="prev"></i>
        <i v-if="isVideo(files[index])" class="el-icon-video-play" @click="viewMedia(index)"></i>
        <i v-else class="el-icon-view" @click="viewMedia(index)"></i>
        <i class="el-icon-arrow-right" @click="next"></i>
      </div>

      <!--预览框-->
      <media-preview ref="mediaPreview"></media-preview>
    </div>
    <div v-else class="main">
      <!--图片墙-->
      <div class="pictures">
        <!--图片-->
        <div class="picture">
          <i class="el-icon-picture-outline"></i>
          <p>列表为空</p>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    files: { type: Array, require: true }
  },
  computed: {
    fileSize() {
      if (this.files === null || this.files === undefined) return 0;
      return this.files.length;
    }
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_API,
      index: 0,
      interval: null,
    }
  },
  mounted() {
    this.startAutoPlay();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    //开始轮播
    startAutoPlay() {
      this.interval = setInterval(() => {
        this.next();
      }, 3000);
    },
    //暂停轮播
    pauseAutoPlay() {
      clearInterval(this.interval);
    },
    //恢复轮播
    resumeAutoPlay() {
      this.startAutoPlay();
    },
    //下一张
    next() {
      if (this.files === null || this.files === undefined) return;
      this.index = (this.index + 1) % this.files.length;
    },
    //上一张
    prev() {
      if (this.files === null || this.files === undefined) return;
      this.index = (this.index - 1 + this.files.length) % this.files.length;
    },
    viewMedia(index) {
      this.$refs.mediaPreview.open(this.files, index)
    },
    isVideo(file) {
      if (!file) return false;
      if (file.indexOf(".mp4") > -1) return true;
      return false;
    },
    getImgUrl(file) {
      //if (file.indexOf(".mp4") > -1) return file.replace(".mp4", ".jpg");
      if (file.indexOf(".mp4") > -1) return  this.baseUrl+'/profile/images/video.png';
      return file;
    },
    handleImageError(event) {
      if (event.target && event.target.src) {
        event.target.src = "/images/img404.png";
        event.target.onerror = null; // 防止循环报错
      }
    }
  }
}
</script>

<style scoped lang="scss">
.main {
  position: relative;
  width: 150px;
  height: 150px;
  margin: 0;
  overflow: hidden;
  border-radius: 6px;
  border: 1px dashed #1890ff;
}

.pictures {
  display: flex;
  height: 150px;
  transition: transform 2s linear;
}

.picture {
  top: 0;
  left: 0;
  width: 150px;
  height: 150px;

  i {
    margin-top: 12px;
    ;
    font-size: 100px;
  }

  p {
    margin-top: -5px;
  }
}



.picture img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.preview {
  z-index: 9;
  position: absolute;
  top: 0;
  left: 0;

  width: 150px;
  height: 150px;
  border-radius: 5px;

  font-size: 20px;
  color: white;
  background-color: black;
  opacity: 0;

  display: flex;
  justify-content: space-between;
  align-items: center;
}

.preview i {
  z-index: 11;
}

.preview i:hover {
  cursor: pointer;
}

.preview:hover {
  opacity: 0.5;
}

.triangle {
  position: absolute;
  top: 0;
  right: 0;
  width: 30px;
  height: 30px;
  border-top-right-radius: 5px;
  background: linear-gradient(45deg, transparent 50%, rgb(109, 189, 109) 50%);
}

.remark {
  position: absolute;
  z-index: 5;
  top: 0;
  right: 4px;
  transform: rotate(45deg);
  color: white;
}
</style>
